import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from 'react-datepicker';
import { Link } from "react-router-dom";
import ContentHeader from '../../components/ContentHeader';
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import es from "date-fns/locale/es";

registerLocale('es', es);

const Kilometrages = () => {
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(new Date());
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [useDateRange, setUseDateRange] = useState(false);
    const [kilometrageId, setKilometrageId] = useState(0);
    const [kilometrages, setKilometrages] = useState([]);
    const [driverId, setDriverId] = useState(0);
    const [drivers, setDrivers] = useState([]);
    const [unitId, setUnitId] = useState(0);
    const [units, setUnits] = useState([]);
    const [kilometrage, setKilometrage] = useState('');
    const [nextServiceKm, setNextServiceKm] = useState('');
    const [description, setDescription] = useState('');
    const [serviceType, setServiceType] = useState('');
    const [unitFilter, setUnitFilter] = useState(0);
    const [roleId, setRoleId] = useState(0);
    const [serviceTitle, setServiceTitle] = useState('');
    const [kmToTravel, setKmToTravel] = useState('');
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    const serviceTypes = [
        { value: 'Mantenimiento', label: 'Mantenimiento' },
        { value: 'Reparación', label: 'Reparación' },        
        { value: 'Revisión', label: 'Revisión' },
        { value: 'Otro', label: 'Otro' }
    ];

    useEffect(() => {
        getAll();
        getDrivers();
        getUnits();
        
        setTimeout(() => {
            $('.select2').select2({ width: "100%", placeholder: "Seleccione", dropdownParent: $('#modal-default') });
            $('#unit_filter').select2({ width: "100%", placeholder: "Seleccione", dropdownParent: $('.card-body') });
        }, 100);

        // Initialize tooltips
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });

        const user = JSON.parse(localStorage.getItem('dataUser'));
        setRoleId(user.rol_id);
    }, []);

    $('#unit_filter').on("change", function (e) {
        setUnitFilter(e.target.value);
    });

    $('#unit_id').on("change", function (e) {
        setUnitId(e.target.value);
    });

    $('#driver_id').on("change", function (e) {
        setDriverId(e.target.value);
    });

    const getDrivers = async () => {
        try {
            const response = await axios.get(ENDPOINT + 'get-kilometrage-drivers');
            const driversArray = response.data.data.map(element => ({
                label: `${element.name} ${element.last_name}`,
                value: element.driver_id,
            }));
            setDrivers(driversArray);
        } catch (error) {
            console.error('Error getting drivers:', error);
        }
    };

    const getUnits = async () => {
        try {
            const response = await axios.get(ENDPOINT + 'get-kilometrage-units');
            const unitsArray = response.data.data.map(element => ({
                label: element.name,
                value: element.unit_id,
            }));
            setUnits(unitsArray);
        } catch (error) {
            console.error('Error getting units:', error);
        }
    };

    const getAll = async () => {
        setLoading(true);
        const form = new FormData();
        form.append('unit_filter', unitFilter);
        
       
        
        try {
            const response = await axios.post(ENDPOINT + 'get-kilometrages', form);
            setKilometrages(response.data.data);
            
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 50,
                    responsive: false,
                    autoWidth: true,
                    paging: true,
                    ordering: false,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "No hay registros de kilometraje",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando 0 registros",
                        "infoFiltered": "(filtrado de _MAX_ registros totales)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No se encontraron registros",
                    },
                });
                setLoading(false);
            }, 100);
        } catch (error) {
            console.error('Error getting kilometrages:', error);
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Solo validar próximo servicio si es Mantenimiento
        

        const formData = {
            unit_id: unitId,
            driver_id: driverId,
            date: date.toISOString().split('T')[0],
            kilometrage: kilometrage,
            next_service_km: kilometrage && kmToTravel
                ? parseFloat(kilometrage) + parseFloat(kmToTravel)
                : null,
            description: description,
            service_type: serviceType,
            title: serviceTitle
        };

        try {
            const endpoint = kilometrageId ? 
                ENDPOINT + 'update-kilometrage/' + kilometrageId : 
                ENDPOINT + 'create-kilometrage';
            
            const method = kilometrageId ? 'put' : 'post';
            
            const response = await axios[method](endpoint, formData);
            
            getAll();
            clearFields();
            setLoading(false);
            $("#closemodal").trigger("click");
            
            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        } catch (error) {
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + (error.response?.data?.msg || 'Error al procesar la solicitud') + "</div>",
                showClass: { popup: "animate__animated animate__fadeInDown" },
                hideClass: { popup: "animate__animated animate__fadeOutUp" },
            });
        }
    };

    const toggleStatus = async (id) => {
        setLoading(true);
        try {
            const response = await axios.get(ENDPOINT + 'toggle-kilometrage-status/' + id);
            getAll();
            setLoading(false);
            Swal.fire({
                icon: 'success',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
        } catch (error) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + (error.response?.data?.msg || 'Error al cambiar estado') + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
        }
    };

    const handleEdit = async (id) => {
        setLoading(true);
        try {
            const response = await axios.get(ENDPOINT + 'get-kilometrage-detail/' + id);
            const data = response.data.data;
            
            setTitle('Editar Registro de Kilometraje');
            setKilometrageId(data.kilometrage_id);
            setUnitId(data.unit_id);
            setDriverId(data.driver_id);
            setDate(new Date(data.date));
            setKilometrage(data.kilometrage);
            setKmToTravel(
                data.next_service_km && data.kilometrage
                    ? parseFloat(data.next_service_km) - parseFloat(data.kilometrage)
                    : ''
            );
            setNextServiceKm(data.next_service_km || '');
            setDescription(data.description || '');
            setServiceType(data.service_type || '');
            setServiceTitle('');
            
            setTimeout(() => {
                $('.select2').select2({ width: "100%", dropdownParent: $('#modal-default') });
            }, 100);
            
            setLoading(false);
        } catch (error) {
            console.error('Error getting kilometrage detail:', error);
            setLoading(false);
        }
    };

    const handleDelete = (id, info) => {
        Swal.fire({
            title: `¿Desea eliminar el registro?`,
            text: `Unidad: ${info}`,
            icon: "warning",
            confirmButtonText: "Sí, eliminarlo",
            confirmButtonColor: "#3085d6",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.delete(ENDPOINT + 'delete-kilometrage/' + id)
                    .then(response => {
                        getAll();
                        setLoading(false);
                        Swal.fire({
                            icon: 'success',
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: false,
                            timer: 3000,
                            html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                            showClass: { popup: 'animate__animated animate__fadeInDown' },
                            hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                        });
                    })
                    .catch(error => {
                        setLoading(false);
                        Swal.fire({
                            icon: 'error',
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            html: '<div class="text-custom-alert">' + (error.response?.data?.msg || 'Error al eliminar') + '</div>',
                            showClass: { popup: 'animate__animated animate__fadeInDown' },
                            hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                        });
                    });
            }
        });
    };

    const clearFields = () => {
        setKilometrageId(0);
        setUnitId(0);
        setDriverId(0);
        setKilometrage('');
        setKmToTravel(''); // <-- Agrega esto
        setNextServiceKm('');
        setDescription('');
        setServiceType('');
        setDate(new Date());
        setServiceTitle('');
    };

    const handleAddNew = () => {
        setTitle('Nuevo Registro de Kilometraje');
        clearFields();
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatNumber = (number) => {
        return new Intl.NumberFormat('es-MX').format(number);
    };

    // Nuevas funciones para calcular el estado del servicio
    const getServiceStatusColor = (currentKm, estimatedKm, nextServiceKm) => {
        if (!nextServiceKm || !estimatedKm) return '';
        
        const totalEstimated = parseFloat(currentKm) + parseFloat(estimatedKm);
        const next = parseFloat(nextServiceKm);
        const difference = next - totalEstimated;
        
        if (difference <= 500) {
            return 'text-danger'; // Rojo - muy cerca o pasado
        } else if (difference <= 4000) {
            return 'text-warning'; // Amarillo - acercándose
        } else {
            return 'text-success'; // Verde - buen margen
        }
    };

    const getServiceStatusText = (currentKm, estimatedKm, nextServiceKm) => {
        if (!nextServiceKm || !estimatedKm) return 'N/A';
        
        const totalEstimated = parseFloat(currentKm) + parseFloat(estimatedKm);
        const next = parseFloat(nextServiceKm);
        const difference = next - totalEstimated;
        
        if (difference <= 250) {
            return 'Pasado o En Km';
        } else if (difference <= 1500) {
            return 'Próximo';
        } else if (difference <= 4500) {
            return 'En Progreso';
        } else {
            return 'Reciente Cambio';
        }
    };

    return (
        <>
            {loading && <Loader />}
            
            {/* Modal para agregar/editar */}
            <div className="modal fade" id="modal-default" aria-labelledby="modal-default" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">{title}</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Unidad <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="unit_id"
                                                value={unitId}
                                                onChange={(e) => setUnitId(e.target.value)}
                                                required
                                            >
                                                <option value="">Seleccione una unidad</option>
                                                {units.map((item, index) => (
                                                    <option key={index} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Conductor <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="driver_id"
                                                value={driverId}
                                                onChange={(e) => setDriverId(e.target.value)}
                                                required
                                            >
                                                <option value="">Seleccione un conductor</option>
                                                {drivers.map((item, index) => (
                                                    <option key={index} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Fecha <span className="text-danger">*</span>
                                            </label>
                                            <DatePicker
                                                selected={date}
                                                onChange={(date) => setDate(date)}
                                                className="form-control form-control-sm"
                                                dateFormat="dd/MM/yyyy"
                                                locale="es"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Kilometraje <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={kilometrage}
                                                onChange={(e) => setKilometrage(e.target.value)}
                                                step="0.01"
                                                min="0"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Próximo Servicio (Km)
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={
                                                    kilometrage && kmToTravel
                                                        ? parseFloat(kilometrage) + parseFloat(kmToTravel)
                                                        : ''
                                                }
                                                readOnly
                                            />
                                            <small className="form-text text-muted">
                                                Se calcula automáticamente: Kilometraje + Km a Recorrer
                                            </small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Tipo de Servicio
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                value={serviceType}
                                                onChange={(e) => setServiceType(e.target.value)}
                                            >
                                                <option value="">Seleccione tipo</option>
                                                {serviceTypes.map((item, index) => (
                                                    <option key={index} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Título del Servicio <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                value={serviceTitle}
                                                onChange={(e) => setServiceTitle(e.target.value)}
                                                required
                                                placeholder="Ej: Cambio de aceite, Revisión general..."
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Km a Recorrer <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={kmToTravel}
                                                onChange={(e) => setKmToTravel(e.target.value)}
                                                step="0.01"
                                                min="0"
                                                required
                                                placeholder="Ej: 1000"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="col-form-label col-form-label-sm">
                                                Reporte Servicio / Observaciones
                                            </label>
                                            <textarea
                                                className="form-control form-control-sm"
                                                rows="3"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                placeholder="Descripción del servicio realizado..."
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    {kilometrageId ? 'Actualizar' : 'Guardar'}
                                </button>
                                <button
                                    id="closemodal"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={clearFields}
                                >
                                    <i className="fa-solid fa-ban me-1"></i>
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <ContentHeader title="Módulo de Kilometrajes" />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-speedometer2 me-2"></i> Registros de Kilometrajes
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <button
                                    onClick={handleAddNew}
                                    className="btn btn-success btn-sm me-1"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-default"
                                >
                                    <i className="fas fa-plus-circle me-1"></i> Nuevo Registro
                                </button>
                                <button
                                    onClick={getAll}
                                    className="btn btn-info btn-sm me-1"
                                    type="button"
                                >
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="indications row mb-4">
                            <div className="col-md-3 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label className="col-form-label col-form-label-sm">
                                        Filtrar por Unidad
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="unit_filter"
                                    >
                                        <option value="0">Todas las unidades</option>
                                        {units.map((item, index) => (
                                            <option key={index} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label className="col-form-label col-form-label-sm">
                                        {useDateRange ? 'Rango de fechas' : 'Fecha'}
                                    </label>
                                    <div className="form-check form-switch mb-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={useDateRange}
                                            onChange={() => setUseDateRange(!useDateRange)}
                                        />
                                        <label className="form-check-label">
                                            Usar rango
                                        </label>
                                    </div>
                                    {useDateRange ? (
                                        <>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={setStartDate}
                                                selectsStart
                                                startDate={startDate}
                                                endDate={endDate}
                                                className="form-control form-control-sm mb-1"
                                                dateFormat="dd/MM/yyyy"
                                                locale="es"
                                            />
                                            <DatePicker
                                                selected={endDate}
                                                onChange={setEndDate}
                                                selectsEnd
                                                startDate={startDate}
                                                endDate={endDate}
                                                minDate={startDate}
                                                className="form-control form-control-sm"
                                                dateFormat="dd/MM/yyyy"
                                                locale="es"
                                            />
                                        </>
                                    ) : (
                                        <DatePicker
                                            selected={date}
                                            onChange={setDate}
                                            className="form-control form-control-sm"
                                            dateFormat="dd/MM/yyyy"
                                            locale="es"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 mb-2 d-flex align-items-end">
                                <button
                                    onClick={getAll}
                                    className="btn btn-primary btn-sm"
                                    type="button"
                                >
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                            </div>
                        </div>

                        <table className="table table-hover main table-striped">
                            <thead>
                                <tr>
                                    <th width="5%">#</th>
                                    <th width="6%">Fecha del Servicio</th>
                                    <th width="6%">Unidad</th>
                                    <th width="10%">Conductor</th>
                                    
                                    <th width="7%" className="text-right">Kilometraje</th>
                                    <th width="10%" className="text-right">Próximo Servicio</th>
                                   
                                    <th width="4%" className="text-right">#🛩️</th>
                                    <th width="7%" className="text-right">Kms Estimados</th>
                                    <th width="10%">Tipo Servicio</th>
                                    <th width="10%">Título Servicio</th>
                                    <th width="30%">Servico Detalle</th>
                                    <th width="13%" className="text-right">Para Proximo</th>
                                    <th width="10%">Estado</th>
                                    <th width="10%">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {kilometrages.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <kbd>#{item.kilometrage_id}</kbd>
                                        </td>
                                        <td>{item.date}</td>
                                        <td>{item.unit?.name}</td>
                                        <td>{item.driver ? `${item.driver.name} ${item.driver.last_name}` : 'N/A'}</td>
                                        
                                        <td className="text-right">{formatNumber(item.kilometrage)} km</td>
                                        <td className="text-right">
                                            {item.next_service_km ? formatNumber(item.next_service_km) + ' km' : 'N/A'}
                                        </td>
                                        
                                        <td className="text-right">{item.trips_count || 0}</td>
                                        <td className="text-right">{formatNumber(item.estimated_kilometrage || 0)} km</td>
                                        <td>{item.service_type || 'N/A'}</td>
                                        <td>{item.title || 'N/A'}</td>
                                        <td>{item.description || 'N/A'}</td>
                                        
                                        <td className="text-right">
                                            {item.notification_read === 1 ? (
                                                <span className="fw-bold text-primary">Servicio realizado</span>
                                            ) : (
                                                item.next_service_km && item.estimated_kilometrage && (
                                                    <span className={`fw-bold ${getServiceStatusColor(
                                                        item.kilometrage, 
                                                        item.estimated_kilometrage, 
                                                        item.next_service_km
                                                    )}`}>
                                                        {getServiceStatusText(
                                                            item.kilometrage, 
                                                            item.estimated_kilometrage, 
                                                            item.next_service_km
                                                        )}
                                                    </span>
                                                )
                                            )}
                                        </td>
                                        <td>
                                            <Switch
                                                onChange={() => toggleStatus(item.kilometrage_id)}
                                                checked={item.status === 1}
                                                offColor="#dc3545"
                                                onColor="#198754"
                                                height={20}
                                                width={40}
                                                disabled={roleId !== 1}
                                            />
                                        </td>
                                        <td>
                                            <div className="btn-group">
                                                <button
                                                    className="btn btn-info btn-sm"
                                                    data-bs-toggle="tooltip"
                                                    title="Editar"
                                                    onClick={() => handleEdit(item.kilometrage_id)}
                                                    data-bs-target="#modal-default"
                                                >
                                                    <i className="fas fa-edit"></i>
                                                </button>
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    data-bs-toggle="tooltip"
                                                    title="Eliminar"
                                                    onClick={() => handleDelete(item.kilometrage_id, item.unit?.name)}
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Estilos CSS para los estados de servicio */}
            <style>
                {`
                .text-danger { color: #dc3545 !important; }
                .text-warning { color: #ffc107 !important; }
                .text-success { color: #198754 !important; }
                .fw-bold { font-weight: bold !important; }
                `}
            </style>
        </>
    );
};

export default Kilometrages;